import AppliedFilters from '@bd/bdui-appliedfilters';
import styled from '@bd/bdui-styles/emotion';

export default styled(AppliedFilters)`
  position: relative;
  padding: 0 20px;
  display: flex;
  align-items: center;
  background-color:white;
  @media(min-width: 992px) {
    padding: 0 40px;
  }
  .AppliedFilters_list {
    margin: 0;
    padding: 10px 0;
    list-style: none;
    display: inline-block;
    flex: 1;
    &:before {
      @media(min-width: 992px) {
        content: 'Applied Filters:';
        display: inline-block;
        margin: 0 10px 0 0;
        font-size: 14px;
        font-weight: 700;
      }
    }
    .AppliedFilters_listItem {
      display: inline-block;
      margin: 0 10px 10px 0;
    }
    .AppliedFilters_listItemButton {
      padding: 6px 35px 6px 15px;
      font-weight: 500;
      font-size: 12px;
      color: #000000;
      background-image: url('/images/icons/filter-close.svg');
      background-position: 95% center;
      background-repeat: no-repeat;
      background-size: 16px 16px;
      cursor: pointer;
      background-color: #F4F4F4;
      letter-spacing: 0;
      &:focus {
        outline: none;
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/AppliedFilters.js